import { Anchor, Button, Table, Text } from '@mantine/core';
import { IconCopy } from '@tabler/icons-react';
import copyText from '../helpers/copyText';

// Every required record renders the same way, so the row - copy buttons and the
// missing-token fallback included - lives in one place. `idPrefix` keeps the
// element ids copyText() looks up unique per row.
export const DnsRecordRow = ({ record, idPrefix, dataTour, defaultType }) => (
  <Table.Tr
    data-tour={dataTour}
    style={{
      backgroundColor: record.valid ? 'var(--mantine-color-success-3)' : 'var(--mantine-color-danger-3)',
    }}
  >
    {record.record ? (
      <>
        <Table.Td>{record.type || defaultType}</Table.Td>
        <Table.Td style={{ wordBreak: 'break-all', overflowWrap: 'break-word' }}>
          <span id={`${idPrefix}Host`}>{record.domain}</span>
          <Button variant="subtle" size="xs" onClick={() => copyText(`${idPrefix}Host`)}>
            <IconCopy size={14} />
          </Button>
        </Table.Td>
        <Table.Td style={{ wordBreak: 'break-all', overflowWrap: 'break-word' }}>
          <span id={`${idPrefix}Value`}>{record.record}</span>
          <Button variant="subtle" size="xs" onClick={() => copyText(`${idPrefix}Value`)}>
            <IconCopy size={14} />
          </Button>
        </Table.Td>
      </>
    ) : (
      <Table.Td colSpan={3}>
        <Text ta="center">
          No verification token found. Please reach out to{' '}
          <Anchor href="mailto:support@releva.ai">support@releva.ai</Anchor> for assistance.
        </Text>
      </Table.Td>
    )}
  </Table.Tr>
);

const DnsRecordsTable = ({ children }) => (
  <Table withTableBorder style={{ tableLayout: 'fixed', width: '100%' }}>
    <Table.Thead>
      <Table.Tr>
        <Table.Th style={{ width: '60px' }}>Type</Table.Th>
        <Table.Th style={{ width: '30%' }}>Host</Table.Th>
        <Table.Th>Value</Table.Th>
      </Table.Tr>
    </Table.Thead>
    <Table.Tbody>{children}</Table.Tbody>
  </Table>
);

export default DnsRecordsTable;
